"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _context12 = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _TextBase = _interopRequireDefault(require("./TextBase"));
var _excluded = ["isButton", "active", "children", "size"],
  _excluded2 = ["classNames", "variant", "size", "color", "disabled", "value", "validation", "transformValue", "enableUpdateValueAfterTransform", "transformValueForValidation", "onClick", "href", "endIcon", "ContainerComponent", "ContainerProps", "label", "LabelComponent", "LabelProps", "helperText", "HelperTextComponent", "HelperTextProps", "error", "errorMessage", "ErrorMessageComponent", "ErrorMessageProps", "ErrorMessageTypographyComponent", "ErrorMessageTypographyProps", "InputComponent", "InputProps", "Component", "disableButtonPaper", "preventDefaultOnClick", "effect", "needErrorUpdate"],
  _excluded3 = ["children", "value", "effect", "changedEver", "getFocus", "validation"],
  _excluded4 = ["href"];
var defaultStyle = require("./../empty_css.js")["default"];
var _EndIconContainerComponent = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var isButton = _ref.isButton,
    active = _ref.active,
    children = _ref.children,
    size = _ref.size,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (isButton) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({}, props, {
      Component: 'div',
      size: 'none',
      disableElevation: true,
      ButtonBaseContentComponent: function ButtonBaseContentComponent() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
      },
      ref: ref,
      style: {
        backgroundColor: 'transparent',
        borderStyle: 'none',
        boxShadow: 'none'
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({}, props, {
    ref: ref
  }), children);
});
var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref5) {
  var _rest$classes;
  var _useContext = (0, _react.useContext)(_context12["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.input || defaultStyle : _props$classNames,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'contained' : _props$variant,
    _props$size = props.size,
    size = _props$size === void 0 ? variant === 'inline' ? 'none' : 'default' : _props$size,
    color = props.color,
    disabled = props.disabled,
    value = props.value,
    validation = props.validation,
    _props$transformValue = props.transformValue,
    transformValue = _props$transformValue === void 0 ? function (value) {
      return value;
    } : _props$transformValue,
    _props$enableUpdateVa = props.enableUpdateValueAfterTransform,
    enableUpdateValueAfterTransform = _props$enableUpdateVa === void 0 ? false : _props$enableUpdateVa,
    _props$transformValue2 = props.transformValueForValidation,
    transformValueForValidation = _props$transformValue2 === void 0 ? function (value) {
      return value;
    } : _props$transformValue2,
    _onClick = props.onClick,
    href = props.href,
    endIcon = props.endIcon,
    _props$ContainerCompo = props.ContainerComponent,
    ContainerComponent = _props$ContainerCompo === void 0 ? 'div' : _props$ContainerCompo,
    _props$ContainerProps = props.ContainerProps,
    ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$LabelComponent = props.LabelComponent,
    LabelComponent = _props$LabelComponent === void 0 ? _Typography["default"] : _props$LabelComponent,
    _props$LabelProps = props.LabelProps,
    LabelProps = _props$LabelProps === void 0 ? {} : _props$LabelProps,
    _props$helperText = props.helperText,
    helperText = _props$helperText === void 0 ? '' : _props$helperText,
    _props$HelperTextComp = props.HelperTextComponent,
    HelperTextComponent = _props$HelperTextComp === void 0 ? function (_ref2) {
      var children = _ref2.children,
        value = _ref2.value,
        effect = _ref2.effect,
        changedEver = _ref2.changedEver,
        getFocus = _ref2.getFocus,
        validation = _ref2.validation,
        props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded3);
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], props, children);
    } : _props$HelperTextComp,
    _props$HelperTextProp = props.HelperTextProps,
    HelperTextProps = _props$HelperTextProp === void 0 ? {} : _props$HelperTextProp,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$errorMessage = props.errorMessage,
    errorMessage = _props$errorMessage === void 0 ? '' : _props$errorMessage,
    _props$ErrorMessageCo = props.ErrorMessageComponent,
    ErrorMessageComponent = _props$ErrorMessageCo === void 0 ? _Paper["default"] : _props$ErrorMessageCo,
    _props$ErrorMessagePr = props.ErrorMessageProps,
    ErrorMessageProps = _props$ErrorMessagePr === void 0 ? {} : _props$ErrorMessagePr,
    _props$ErrorMessageTy = props.ErrorMessageTypographyComponent,
    ErrorMessageTypographyComponent = _props$ErrorMessageTy === void 0 ? _Typography["default"] : _props$ErrorMessageTy,
    _props$ErrorMessageTy2 = props.ErrorMessageTypographyProps,
    ErrorMessageTypographyProps = _props$ErrorMessageTy2 === void 0 ? {} : _props$ErrorMessageTy2,
    _props$InputComponent = props.InputComponent,
    InputComponent = _props$InputComponent === void 0 ? _TextBase["default"] : _props$InputComponent,
    _props$InputProps = props.InputProps,
    InputProps = _props$InputProps === void 0 ? {} : _props$InputProps,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    disableButtonPaper = props.disableButtonPaper,
    preventDefaultOnClick = props.preventDefaultOnClick,
    effect = props.effect,
    needErrorUpdate = props.needErrorUpdate,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  if (classNames !== additionalStyles.input) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var containerRef = (0, _react.useRef)();
  var inputBaseActions = (0, _react.useRef)({});
  var helperTextActions = (0, _react.useRef)({});
  var changedEver = (0, _react.useRef)(false);
  var isFocus = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)({
      error: error,
      errorMessage: errorMessage
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _error = _useState2[0],
    setError = _useState2[1];
  var buttonRef = (0, _react.useRef)({});
  function _runValidation2(_x, _x2) {
    return _runValidation.apply(this, arguments);
  }
  function _runValidation() {
    _runValidation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee0(_value, callOutside) {
      var _inputBaseActions$cur13, _inputBaseActions$cur14;
      var value, isValid;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            value = typeof _value !== 'undefined' ? _value : (_inputBaseActions$cur13 = inputBaseActions.current) === null || _inputBaseActions$cur13 === void 0 ? void 0 : (_inputBaseActions$cur14 = _inputBaseActions$cur13.actions) === null || _inputBaseActions$cur14 === void 0 ? void 0 : _inputBaseActions$cur14.getValue();
            if (!callOutside) {
              value = transformValueForValidation(transformValue(value));
            }
            if (!validation) {
              _context0.next = 10;
              break;
            }
            _context0.next = 5;
            return validation(value, callOutside || changedEver.current);
          case 5:
            isValid = _context0.sent;
            if (!(isValid.error !== _error.error || isValid.errorMessage !== _error.errorMessage)) {
              _context0.next = 10;
              break;
            }
            _context0.next = 9;
            return setError({
              error: isValid.error || false,
              errorMessage: isValid.errorMessage || ''
            });
          case 9:
            return _context0.abrupt("return", {
              error: isValid.error || false,
              errorMessage: isValid.errorMessage || ''
            });
          case 10:
            return _context0.abrupt("return", _error);
          case 11:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return _runValidation.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    function next() {
      return _next.apply(this, arguments);
    }
    function _next() {
      _next = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var _inputBaseActions$cur, _inputBaseActions$cur2, _inputBaseActions$cur3, _inputBaseActions$cur4;
        var v;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              v = (_inputBaseActions$cur = inputBaseActions.current) !== null && _inputBaseActions$cur !== void 0 && (_inputBaseActions$cur2 = _inputBaseActions$cur.actions) !== null && _inputBaseActions$cur2 !== void 0 && _inputBaseActions$cur2.getValue ? (_inputBaseActions$cur3 = inputBaseActions.current) === null || _inputBaseActions$cur3 === void 0 ? void 0 : (_inputBaseActions$cur4 = _inputBaseActions$cur3.actions) === null || _inputBaseActions$cur4 === void 0 ? void 0 : _inputBaseActions$cur4.getValue() : value;
              _context.next = 3;
              return _runValidation2(v);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _next.apply(this, arguments);
    }
    if (!_error.error) {
      next();
    }
  }, []);
  var endIconRef = (0, _react.useRef)();
  var isButton = (_onClick || href) && endIcon;
  (0, _react.useEffect)(function () {
    if (error !== _error.error || errorMessage !== _error.errorMessage) {
      setError({
        error: error,
        errorMessage: errorMessage
      });
    }
  }, [error, errorMessage, needErrorUpdate]);
  (0, _react.useEffect)(function () {
    if (effect) {
      var _buttonRef$current, _buttonRef$current2;
      effect((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current ? buttonRef.current : {}), {}, {
        actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (_buttonRef$current = buttonRef.current) !== null && _buttonRef$current !== void 0 && _buttonRef$current.actions ? (_buttonRef$current2 = buttonRef.current) === null || _buttonRef$current2 === void 0 ? void 0 : _buttonRef$current2.actions : {}), {}, {
          isError: function isError() {
            return _error.error;
          },
          setError: setError,
          getValue: function getValue() {
            var _inputBaseActions$cur5, _inputBaseActions$cur6;
            return transformValue((_inputBaseActions$cur5 = inputBaseActions.current) === null || _inputBaseActions$cur5 === void 0 ? void 0 : (_inputBaseActions$cur6 = _inputBaseActions$cur5.actions) === null || _inputBaseActions$cur6 === void 0 ? void 0 : _inputBaseActions$cur6.getValue());
          },
          runValidation: function () {
            var _runValidation3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(value) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _runValidation2(value, true);
                  case 2:
                    return _context2.abrupt("return", _context2.sent);
                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            function runValidation(_x3) {
              return _runValidation3.apply(this, arguments);
            }
            return runValidation;
          }(),
          getRef: function getRef() {
            return containerRef.current;
          },
          setValue: function () {
            var _setValue = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(value) {
              var _inputBaseActions$cur7, _inputBaseActions$cur8;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return (_inputBaseActions$cur7 = inputBaseActions.current) === null || _inputBaseActions$cur7 === void 0 ? void 0 : (_inputBaseActions$cur8 = _inputBaseActions$cur7.actions) === null || _inputBaseActions$cur8 === void 0 ? void 0 : _inputBaseActions$cur8.setValue(value);
                  case 2:
                    _context3.next = 4;
                    return onChange({
                      target: {
                        value: value
                      }
                    }, value);
                  case 4:
                    _context3.next = 6;
                    return onBlur({
                      target: {
                        value: value
                      }
                    }, value);
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            function setValue(_x4) {
              return _setValue.apply(this, arguments);
            }
            return setValue;
          }(),
          setDisabled: function () {
            var _setDisabled = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(value) {
              var _buttonRef$current3, _buttonRef$current3$a, _inputBaseActions$cur9, _inputBaseActions$cur0;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!((_buttonRef$current3 = buttonRef.current) !== null && _buttonRef$current3 !== void 0 && (_buttonRef$current3$a = _buttonRef$current3.actions) !== null && _buttonRef$current3$a !== void 0 && _buttonRef$current3$a.setDisabled)) {
                      _context4.next = 3;
                      break;
                    }
                    _context4.next = 3;
                    return buttonRef.current.actions.setDisabled(value);
                  case 3:
                    if (!((_inputBaseActions$cur9 = inputBaseActions.current) !== null && _inputBaseActions$cur9 !== void 0 && (_inputBaseActions$cur0 = _inputBaseActions$cur9.actions) !== null && _inputBaseActions$cur0 !== void 0 && _inputBaseActions$cur0.setDisabled)) {
                      _context4.next = 6;
                      break;
                    }
                    _context4.next = 6;
                    return inputBaseActions.current.actions.setDisabled(value);
                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            function setDisabled(_x5) {
              return _setDisabled.apply(this, arguments);
            }
            return setDisabled;
          }(),
          focus: function focus(e) {
            var _inputBaseActions$cur1, _inputBaseActions$cur10;
            (_inputBaseActions$cur1 = inputBaseActions.current) === null || _inputBaseActions$cur1 === void 0 ? void 0 : (_inputBaseActions$cur10 = _inputBaseActions$cur1.actions) === null || _inputBaseActions$cur10 === void 0 ? void 0 : _inputBaseActions$cur10.focus(e);
          }
        })
      }));
    }
    return function () {
      if (effect) {
        var _buttonRef$current4, _buttonRef$current5;
        effect((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current ? buttonRef.current : {}), {}, {
          actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (_buttonRef$current4 = buttonRef.current) !== null && _buttonRef$current4 !== void 0 && _buttonRef$current4.actions ? Object.keys((_buttonRef$current5 = buttonRef.current) === null || _buttonRef$current5 === void 0 ? void 0 : _buttonRef$current5.actions).reduce(function (o, key) {
            o[key] = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    return _context5.abrupt("return", null);
                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));
            return o;
          }, {}) : {}), {}, {
            isError: function () {
              var _isError = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      return _context6.abrupt("return", null);
                    case 1:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              function isError() {
                return _isError.apply(this, arguments);
              }
              return isError;
            }(),
            setError: function () {
              var _setError = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      return _context7.abrupt("return", null);
                    case 1:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              function setError() {
                return _setError.apply(this, arguments);
              }
              return setError;
            }(),
            getValue: function getValue() {
              return null;
            },
            runValidation: function () {
              var _runValidation4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      return _context8.abrupt("return", null);
                    case 1:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              function runValidation() {
                return _runValidation4.apply(this, arguments);
              }
              return runValidation;
            }(),
            getRef: function getRef() {
              return null;
            },
            setValue: function () {
              var _setValue2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      return _context9.abrupt("return", null);
                    case 1:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              function setValue() {
                return _setValue2.apply(this, arguments);
              }
              return setValue;
            }(),
            focus: function focus() {
              return null;
            }
          })
        }));
      }
    };
  });
  function onChange(_x6, _x7) {
    return _onChange.apply(this, arguments);
  }
  function _onChange() {
    _onChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee1(e, value) {
      var _helperTextActions$cu;
      var attr;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee1$(_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            changedEver.current = true;
            isFocus.current = true;
            if (!(_error !== null && _error !== void 0 && _error.error)) {
              _context1.next = 5;
              break;
            }
            _context1.next = 5;
            return setError({
              error: false,
              errorMessage: ''
            });
          case 5:
            if (!((_helperTextActions$cu = helperTextActions.current.actions) !== null && _helperTextActions$cu !== void 0 && _helperTextActions$cu.setValue)) {
              _context1.next = 8;
              break;
            }
            _context1.next = 8;
            return helperTextActions.current.actions.setValue(value);
          case 8:
            if (!InputProps.onChange) {
              _context1.next = 12;
              break;
            }
            attr = props.transformValue ? [e, transformValue(value), value] : [e, value];
            _context1.next = 12;
            return InputProps.onChange.apply(InputProps, attr);
          case 12:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return _onChange.apply(this, arguments);
  }
  function onBlur(_x8, _x9) {
    return _onBlur.apply(this, arguments);
  }
  function _onBlur() {
    _onBlur = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11(e, value) {
      var _helperTextActions$cu2;
      var attr, next, _next2;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _next2 = function _next4() {
              _next2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10() {
                var newErrorObject, newError, newErrorMessage, _newError, _newErrorMessage;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      if (!validation) {
                        _context10.next = 13;
                        break;
                      }
                      _context10.next = 3;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 1);
                      });
                    case 3:
                      _context10.next = 5;
                      return validation(transformValueForValidation(transformValue(value)), changedEver.current);
                    case 5:
                      newErrorObject = _context10.sent;
                      newError = newErrorObject.error || false;
                      newErrorMessage = newErrorObject.errorMessage || '';
                      if (!(newError !== _error.error || newErrorMessage !== _error.errorMessage)) {
                        _context10.next = 11;
                        break;
                      }
                      _context10.next = 11;
                      return setError({
                        error: newError,
                        errorMessage: newErrorMessage
                      });
                    case 11:
                      _context10.next = 18;
                      break;
                    case 13:
                      _newError = false;
                      _newErrorMessage = '';
                      if (!(_newError !== _error.error || _newErrorMessage !== _error.errorMessage)) {
                        _context10.next = 18;
                        break;
                      }
                      _context10.next = 18;
                      return setError({
                        error: _newError,
                        errorMessage: _newErrorMessage
                      });
                    case 18:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return _next2.apply(this, arguments);
            };
            next = function _next3() {
              return _next2.apply(this, arguments);
            };
            changedEver.current = true;
            isFocus.current = false;
            if (!((_helperTextActions$cu2 = helperTextActions.current.actions) !== null && _helperTextActions$cu2 !== void 0 && _helperTextActions$cu2.update)) {
              _context11.next = 7;
              break;
            }
            _context11.next = 7;
            return helperTextActions.current.actions.update();
          case 7:
            if (!InputProps.onBlur) {
              _context11.next = 11;
              break;
            }
            attr = props.transformValue ? [e, transformValue(value), value] : [e, value];
            _context11.next = 11;
            return InputProps.onBlur.apply(InputProps, attr);
          case 11:
            next();
            if (!(transformValue(value) !== value && enableUpdateValueAfterTransform)) {
              _context11.next = 15;
              break;
            }
            _context11.next = 15;
            return inputBaseActions.current.actions.setValue(transformValue(value));
          case 15:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _onBlur.apply(this, arguments);
  }
  return /*#__PURE__*/_react["default"].createElement(ContainerComponent, Object.assign({
    ref: function ref(e) {
      containerRef.current = e;
      if (_ref5) {
        if (typeof _ref5 === 'function') {
          _ref5(e);
        } else if (_ref5 && typeof _ref5 === 'object') {
          _ref5.current = e;
        }
      }
    }
  }, ContainerProps, {
    className: (0, _clsx4["default"])(classNames.inputContainer, ContainerProps.className),
    style: (0, _objectSpread2["default"])({
      '--karrierhub-input-label-padding-x': 'calc(var(--karrierhub-button-input-' + size + '-padding-x)*var(--karrierhub-button-padding-multiplier, 1) * var(--karrierhub-input-label-padding-x-multiplier))'
    }, ContainerProps.style ? ContainerProps.style : {})
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames.inputHeader
  }, label ? /*#__PURE__*/_react["default"].createElement(LabelComponent, Object.assign({
    variant: 'subtitle2',
    Component: 'div'
  }, LabelProps, {
    className: (0, _clsx4["default"])(classNames.inputLabel, LabelProps.className)
  }), label) : null, helperText ? /*#__PURE__*/_react["default"].createElement(HelperTextComponent, Object.assign({
    variant: 'subtitle2',
    Component: 'div'
  }, HelperTextProps, {
    className: (0, _clsx4["default"])(classNames.inputHelperText, LabelProps.className),
    getFocus: function getFocus() {
      return isFocus.current;
    },
    value: value,
    validation: validation,
    changedEver: changedEver,
    effect: function effect(p) {
      var actions = p.actions;
      helperTextActions.current.actions = actions;
      if (HelperTextProps.effect) {
        HelperTextProps.effect(p);
      }
    }
  }), helperText) : null), /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({}, rest, {
    Component: Component,
    color: _error !== null && _error !== void 0 && _error.error ? 'error' : color,
    onClick: function onClick(e, _ref4) {
      var href = _ref4.href,
        rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
      if (preventDefaultOnClick || isButton && (e.target && endIconRef.current && e.target === endIconRef.current || e.target && endIconRef.current && endIconRef.current.contains(e.target))) {
        if (_onClick) {
          _onClick(e, (0, _objectSpread2["default"])({
            href: href
          }, rest));
        }
      } else {
        var _inputBaseActions$cur11, _inputBaseActions$cur12;
        e.preventDefault();
        e.stopPropagation();
        if ((_inputBaseActions$cur11 = inputBaseActions.current) !== null && _inputBaseActions$cur11 !== void 0 && (_inputBaseActions$cur12 = _inputBaseActions$cur11.actions) !== null && _inputBaseActions$cur12 !== void 0 && _inputBaseActions$cur12.focus) {
          inputBaseActions.current.actions.focus();
        }
      }
    },
    href: isButton && href ? href : undefined,
    children: null,
    label: null,
    fullWidth: true,
    variant: variant,
    size: 'input-' + size,
    disabled: disabled,
    TypographyProps: (0, _objectSpread2["default"])({
      variant: variant === 'inline' ? 'input-' + variant : 'input-' + size
    }, rest.TypographyProps ? rest.TypographyProps : {}),
    className: (0, _clsx4["default"])(classNames.input, (0, _defineProperty2["default"])({}, classNames[variant], variant && classNames[variant]), (0, _defineProperty2["default"])({}, classNames.disabled, disabled), (0, _defineProperty2["default"])({}, classNames.disableButtonPaper, disableButtonPaper), rest.className),
    classes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rest.classes ? rest.classes : {}), {}, {
      label: (0, _clsx4["default"])(classNames.buttonLabel, (_rest$classes = rest.classes) === null || _rest$classes === void 0 ? void 0 : _rest$classes.label)
    }),
    EndIconContainerComponent: function EndIconContainerComponent(props) {
      return /*#__PURE__*/_react["default"].createElement(_EndIconContainerComponent, Object.assign({}, props, {
        isButton: isButton,
        ref: endIconRef
      }));
    },
    endIcon: endIcon,
    effect: function effect(p) {
      buttonRef.current = p;
    }
  }), /*#__PURE__*/_react["default"].createElement(InputComponent, Object.assign({
    value: value,
    disabled: disabled,
    size: size
  }, InputProps, {
    PaperProps: (0, _objectSpread2["default"])({
      variant: variant,
      color: _error !== null && _error !== void 0 && _error.error ? 'error' : color
    }, InputProps.PaperProps ? InputProps.PaperProps : {}),
    classNames: classNames,
    disableUseStyle: true,
    onChange: onChange,
    onBlur: onBlur,
    effect: function effect(p) {
      var actions = p.actions;
      inputBaseActions.current.actions = actions;
      if (InputProps.effect) {
        InputProps.effect(p);
      }
    },
    containerRef: containerRef,
    parentButtonPaperDisabled: disableButtonPaper
  }))), _error !== null && _error !== void 0 && _error.error && _error !== null && _error !== void 0 && _error.errorMessage ? /*#__PURE__*/_react["default"].createElement(ErrorMessageComponent, Object.assign({}, ErrorMessageProps, {
    size: 'none',
    elevation: 0,
    color: 'error',
    className: (0, _clsx4["default"])(classNames.inputErrorText, ErrorMessageProps.className)
  }), /*#__PURE__*/_react["default"].createElement(ErrorMessageTypographyComponent, Object.assign({
    variant: 'subtitle2',
    Component: 'div'
  }, ErrorMessageTypographyProps), _error.errorMessage)) : null);
});
var _default = exports["default"] = Input;